<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block">{{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <ng-container>
        <div style="padding: 16px 24px 16px 24px;">
            <div class="col-12" style="width: 100%;">
                <div class="row">
                    <div class="col-md-6">
                        <div>
                            <label class="catlabel"> Shipment ID:</label>
                            <input type="text" class="category" [(ngModel)]="shipmentid" [disabled]="true">
                        </div>
                        <div>
                            <label class="catlabel">Supplier:<span style="color:#ff0000">*</span></label>
                            <select class="F1" id="category-drop-down" class="drpDown" [(ngModel)]="supplier">
                                <option [value]="supp.supplier" *ngFor="let supp of supplierDropdown">
                                    {{supp.supplier}}</option>
                            </select>
                        </div>
                        <div>
                            <label class="catlabel">Shipment Type:<span style="color:#ff0000">*</span></label>
                            <select class="F1" id="category-drop-down" class="drpDown" [(ngModel)]="shipmentType">
                                <option [value]="shipmentType.shipmentTypeId"
                                    *ngFor="let shipmentType of shipmentTypeDropDown">
                                    {{shipmentType.description}}</option>
                            </select>
                        </div>
                        <div>
                            <label class="catlabel">Shipment Date:<span style="color:#ff0000">*</span></label>
                            <input type="date" class="category" [(ngModel)]="shipmentDate">
                        </div>
                        <div>
                            <label class="catlabel"> Empty Packaging KG:</label>
                            <input type="text" class="category" [(ngModel)]="emptypackagingKG"
                                (keyup)="(validate($event,'kg'))" (keypress)="keyPressAlphaNumeric($event)">
                        </div>
                        <div>
                            <label class="catlabel"> Empty Packaging Value: </label>
                            <input type="text" class="category" [(ngModel)]="emptypackagingValue"
                                (keyup)="(validate($event,'value'))" (keypress)="keyPressAlphaNumeric($event)">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <label class="catlabel">Invoice Number:
                            </label>
                            <input type="text" class="category" [(ngModel)]="invoiceNumber" [maxlength]="10"
                                (keypress)="keyPressNumericInvoice($event)">
                        </div>
                        <div>
                            <label class="catlabel">Freight Type:
                            </label>
                            <select class="F1" id="category-drop-down" class="drpDown" [(ngModel)]="freightType">
                                <option [value]="freightType.freightTypeId"
                                    *ngFor="let freightType of freightTypeDropDown">
                                    {{freightType.description}}</option>
                            </select>
                        </div>
                        <div>
                            <label class="catlabel">Sets:</label>
                            <input type="number" class="category" [(ngModel)]="sets">
                        </div>
                        <div>
                            <label class="catlabel">Pallets:
                            </label>
                            <input type="number" class="category" [(ngModel)]="pallets">
                        </div>
                        <div>
                            <label class="catlabel"> Net Weight:</label>
                            <input type="text" class="category" [(ngModel)]="netWeight"
                                (keyup)="(validate($event,'kg'))" (keypress)="keyPressAlphaNumeric($event)">
                        </div>
                        <div>
                            <label class="catlabel"> Gross Weight: </label>
                            <input type="text" class="category" [(ngModel)]="grossWeight"
                                (keyup)="(validate($event,'kg'))" (keypress)="keyPressAlphaNumeric($event)">
                        </div>
                        <div>
                            <label class="catlabel"> Part Value: </label>
                            <input type="text" class="category" [(ngModel)]="partValue"
                                (keyup)="(validate($event,'value'))" (keypress)="keyPressAlphaNumeric($event)">
                        </div>
                    </div>
                </div>
                <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
            </div>
        </div>
        <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
            <button (click)="onNoClick()" class="mCancel"> CANCEL
            </button>
            <button class="black-btn" style="display: inline" (click)="saveClick()">
                SAVE
            </button>
        </div>
    </ng-container>
</div>